import type { QueryClient } from "@tanstack/react-query";
import type { RouteObject } from "react-router-dom";

import { MainLayout } from "@/components/organisms/Layout/MainLayout";
import { routePaths } from "@/config/route-paths";
import { RequireRole } from "@/features/auth";
import { handleDynamicImportError } from "@/lib/react-router";
import { convert } from "@/lib/react-router-convert";

export const AnalysisAssistRoutes: (
  queryClient: QueryClient
) => RouteObject[] = (queryClient: QueryClient) => [
  {
    element: <MainLayout isExpand />,
    children: [
      {
        // 作業領域。ロールによる差はなく、所属テナントかどうかだけを見る
        element: <RequireRole allow={["host", "admin", "member"]} />,
        children: [
          {
            path: routePaths.tenants.bannerAnalysis.root.path,
            lazy: () =>
              import("./layout").then(convert(queryClient)).catch((error) =>
                handleDynamicImportError({
                  componentName: "analysis-assist/layout",
                  error,
                })
              ),
            children: [
              {
                // レポート一覧
                index: true,
                lazy: () =>
                  import("./analysis-assist-route")
                    .then(convert(queryClient))
                    .catch((error) =>
                      handleDynamicImportError({
                        componentName:
                          "analysis-assist/routes/analysis-assist-route",
                        error,
                      })
                    ),
              },
              {
                // CSV からの依頼
                path: routePaths.tenants.bannerAnalysis.create.relativePath,
                lazy: () =>
                  import("./menu-banner-csv-route")
                    .then((m) => ({ default: m.MenuBannerCsvRoute }))
                    .then(convert(queryClient))
                    .catch((error) =>
                      handleDynamicImportError({
                        componentName:
                          "analysis-assist/routes/menu-banner-csv-route",
                        error,
                      })
                    ),
              },
            ],
          },
        ],
      },
    ],
  },
];
